import React, { useState, useEffect, useRef, Suspense, lazy } from "react";
import ProductGrid from "./components/ProductGrid";
import "./styles/App.css";
import { Routes, Route, Link } from "react-router-dom";
import ScrollToTopButton from "./components/ScrollToTopButton";
import ErrorBoundary from "./components/ErrorBoundary";
import LoadingIndicator from "./components/LoadingIndicator";

const About = lazy(() => import("./components/About"));
const Contact = lazy(() => import("./components/Contact"));
const GameHub = lazy(() => import("./components/Games/GameHub"));
const ObservationGridWithFilter = lazy(() => import("./components/Observation/ObservationGridWithFilter"));
const NotFound = lazy(() => import("./components/NotFound"));

const App = () => {
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const resizeRequestRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (resizeRequestRef.current) {
        cancelAnimationFrame(resizeRequestRef.current);
      }
      resizeRequestRef.current = requestAnimationFrame(() => {
        setWindowSize(window.innerWidth);
      });
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      if (resizeRequestRef.current) cancelAnimationFrame(resizeRequestRef.current);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogoClick = () => {
    window.location.href = "/";
  };

  const handleMenuClick = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };


  return (
    <div className="app">
      <header className="header">
        <div className="menu-icon" onClick={handleMenuClick} role="button" aria-label="메뉴 열기" aria-expanded={menuOpen}>
          <svg
            width="30" height="30" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
          >
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="18" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </div>
        <div className="logo-container">
          <h1 className="picklite-logo" onClick={handleLogoClick} style={{ cursor: "pointer" }}>
            PICKLITE
          </h1>
        </div>
      </header>

      <nav className={`sidebar ${menuOpen ? "open" : ""}`}>
        <button className="close-button" onClick={closeMenu}>✖</button>
        <ul>
          <li><Link to="/" onClick={closeMenu}>Home</Link></li>
          <li><Link to="/about" onClick={closeMenu}>About</Link></li>
          <li><Link to="/contact" onClick={closeMenu}>Contact</Link></li>
          <li><Link to="/observation" onClick={closeMenu}>관찰일지</Link></li>
          <li><Link to="/game" onClick={closeMenu}>게임</Link></li>
        </ul>
      </nav>

      {menuOpen && <div className="overlay" onClick={closeMenu}></div>}

      <main>
        <ErrorBoundary>
          <Suspense fallback={<LoadingIndicator loading />}>
            <Routes>
              <Route path="/" element={<ProductGrid windowSize={windowSize} />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/observation" element={<ObservationGridWithFilter />} />
              <Route path="/game" element={<GameHub />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </ErrorBoundary>
      </main>

      <footer className="footer">
        <p>© 2025 Picklite - All Rights Reserved.</p>
      </footer>

      {isVisible && <ScrollToTopButton />}

    </div>
  );
};

export default App;
